
const reviews = [
  {
    name: '田中 美咲',
    role: 'UIデザイナー',
    text: '毎朝のルーティンに深蒸し煎茶が加わりました。コーヒーより穏やかに集中できて、午後の作業効率が格段に上がりました。',
    rating: 5,
  },
  {
    name: '佐藤 健太',
    role: 'フリーランスエンジニア',
    text: 'ほうじ茶の香ばしさに癒されます。夜のコーディングのお供に最適。カフェイン控えめなので睡眠にも影響しません。',
    rating: 5,
  },
  {
    name: '山本 あかり',
    role: 'イラストレーター',
    text: '和紅茶の優しい甘みに驚きました。毎月届く新しい茶葉が楽しみで、お茶の時間がクリエイティブの切り替えスイッチになっています。',
    rating: 5,
  },
  {
    name: '鈴木 大輔',
    role: 'スタートアップCEO',
    text: 'オフィスに導入しました。チームのコミュニケーションが増え、お茶を淹れる時間が良いブレイクタイムになっています。',
    rating: 4,
  },
  {
    name: '高橋 ゆい',
    role: '映像クリエイター',
    text: 'パッケージも美しく、デスクに置いておくだけで気分が上がります。シングルオリジンの違いを楽しめるのが嬉しい。',
    rating: 5,
  },
  {
    name: '中村 翔',
    role: 'プロダクトマネージャー',
    text: 'MeVER Chairとの組み合わせが最高です。良い椅子と良いお茶があれば、どこでも最高のワークスペースになります。',
    rating: 5,
  },
];

export default function TeaReviews() {
  return (
    <section className="py-16 sm:py-24 md:py-32 bg-white" aria-labelledby="tea-reviews-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-[#7B8C3E]/10 text-[#7B8C3E] text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            REVIEWS
          </span>
          <h2 id="tea-reviews-heading" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]">
            お客様の声
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            Craft Teaサブスクリプションをご利用のクリエイターの皆さま
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" role="list">
          {reviews.map((review, index) => (
            <article
              key={index}
              className="bg-[#FAF8F5] rounded-xl sm:rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow duration-300"
              role="listitem"
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${
                      i < review.rating ? 'text-amber-400' : 'text-gray-200'
                    }`}
                    aria-hidden="true"
                  ></i>
                ))}
              </div>
              <p className="text-sm text-black/70 font-extralight leading-relaxed mb-6">
                {review.text}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-black/5">
                <div className="w-10 h-10 flex items-center justify-center bg-[#7B8C3E]/10 rounded-full">
                  <i className="ri-user-line text-[#7B8C3E]" aria-hidden="true"></i>
                </div>
                <div>
                  <p className="text-sm font-light text-black">{review.name}</p>
                  <p className="text-xs text-black/50 font-extralight">{review.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
